/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, array, shape, number, arrayOf,
} from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import { Grid } from '@material-ui/core';

import mbpLogger from '@module-logger/mbp';
import GraphqlNoResultsContainer from './GraphqlNoResultsContainer';
import { GRAPHQL_ENV } from '../../../../gql';
import CategoryPageSkeleton from '../../GraphqlSkeletonComponents/CategoryPageSkeleton/CategoryPageSkeleton';

const GraphqlSearchErrorPage = ({
    classes,
    products,
    filterData,
    brand,
    searchTerm,
    pageNumber,
}) => {
    const ERROR_PAGE_QUERY = gql`
    query ErrorPageQuery {
        findContentPage(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", contentType: "template_error_page", url: "/404-page") {
            content
        }
    }
`;
    const { error, loading, data } = useQuery(ERROR_PAGE_QUERY);

    if (loading) {
        return <CategoryPageSkeleton />;
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: ERROR_PAGE_QUERY,
            component: 'GraphqlSearchErrorPage.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
    }

    /**
     * getting text copy if no product return in search query
     */
    const searchPageCopy = data?.findContentPage?.content?.entries?.[0]?.search_page_copy || 'These popular flowers and gifts below might interest you:';

    return (
        <div className={classes.siteContainer}>
            <Grid className={classes.header}>
                <Grid className={classes.numOfResultsContainer}>
                    <Grid container>
                        <div className={classes.resultsTextMain}>
                            <h1>{`We could not find anything${searchTerm && searchTerm !== 'notfound' ? ` for "${searchTerm}".` : '.'}`}</h1>
                            <span>{searchPageCopy}</span>
                        </div>
                    </Grid>
                </Grid>
                <Grid>
                    <GraphqlNoResultsContainer filterData={filterData} brand={brand} pageNumber={pageNumber} searchTerm={searchTerm} />
                </Grid>
            </Grid>
        </div>
    );
};

GraphqlSearchErrorPage.propTypes = {
    classes: object,
    products: arrayOf(shape({
        availability: shape({
            availabilityIndicator: string,
            deliveryDateType: string,
            deliveryMessage: string,
            displayEndDate: string,
            displayStartDate: string,
            earliestShipDate: string,
            latestShipDate: string,
            perishable: string,
            productDeliveryType: string,
            shipAlone: string,
            __typename: string,
        }),
        brand: string,
        image: shape({
            altText: string,
            name: string,
            snipe: string,
            __typename: string,
        }),
        name: string,
        partNumber: string,
        prices: arrayOf(shape({
            currency: string,
            type: string,
            value: number,
            __typename: string,
        })),
        seo: shape({
            url: string,
            __typename: string,
        }),
    })),
    filterData: array,
    brand: shape({
        'domain-name': string.isRequired,
    }).isRequired,
    searchTerm: string.isRequired,
    pageNumber: number,
};

GraphqlSearchErrorPage.defaultProps = {
    classes: {},
    products: [],
    filterData: {},
    pageNumber: 1,
};

export default GraphqlSearchErrorPage;
